import React, { useState, useEffect, useCallback } from 'react';
import { Moon } from 'lucide-react';
import { isQuietNow, getActiveQuietWindow, getQuietHoursPrefs, onQuietHoursPrefsChange } from '../../utils/quietHours';

// Small header moon badge shown while quiet hours are active (alerts paused).
export const QuietHoursBadge = () => {
  const [quiet, setQuiet] = useState(isQuietNow());

  const recheck = useCallback(() => setQuiet(isQuietNow()), []);

  useEffect(() => {
    const unsub = onQuietHoursPrefsChange(recheck);
    const interval = setInterval(recheck, 30000);
    return () => { unsub(); clearInterval(interval); };
  }, [recheck]);

  if (!quiet) return null;

  const prefs = getQuietHoursPrefs();
  const win = getActiveQuietWindow();
  const title = `Quiet hours active${win.weekend ? ' (weekend hours)' : ''} — alerts and sounds paused until ${win.end}${prefs.critical_override !== false ? ' (critical alerts still come through)' : ''}`;

  return (
    <span
      className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 dark:bg-indigo-900/40 dark:text-indigo-300"
      title={title}
      data-testid="quiet-hours-badge"
    >
      <Moon className="w-4 h-4" />
    </span>
  );
};
